export default __webpack_public_path__ + "static/bg768-10850d0d044c3097026f4aa97469cdb0.png";